import React, { Component } from "react";
import { DropzoneArea } from "material-ui-dropzone";
import { translator } from "../utils/i18n";
import { Trans } from "@lingui/macro";

class Upload extends Component {
  state = {
    files: []
  };

  handleChange = files => {
    this.setState({
      files: files
    });
  };

  render() {
    return (
      <form className="upload">
        <DropzoneArea
          dropzoneText={translator()._("W_DRAG_DROP")}
          onChange={this.handleChange}
        />
        <button className="btn-default mt-30">
          <Trans id="CP_SEND" />
        </button>
      </form>
    );
  }
}

export default Upload;
